export default __webpack_public_path__ + "static/media/imacFrame.e1fdefee.svg";